import React from "react";
import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import { COLORS } from "./constants";
import { formatBytes } from "./utils";

export function StorageBar({ storage }) {
  const used  = storage?.usedBytes  || 0;
  const limit = storage?.limitBytes || 10 * 1024 * 1024 * 1024;
  const pct   = limit ? Math.min(100, Math.round((used / limit) * 100)) : 0;
  const barColor = pct >= 90 ? COLORS.red : pct >= 70 ? COLORS.amber : COLORS.cyan;

  return (
    <Box sx={{ p: 1.25, bgcolor: COLORS.panelSoft, border: `1px solid ${COLORS.border}`, borderRadius: "12px" }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={0.5}>
        <Typography sx={{ color: COLORS.text, fontSize: 12, fontWeight: 600 }}>Server storage</Typography>
        <Typography sx={{ color: COLORS.muted, fontSize: 11, fontFamily: "monospace" }}>
          {formatBytes(used)} / {formatBytes(limit)}
        </Typography>
      </Stack>
      <LinearProgress
        variant="determinate" value={pct}
        sx={{
          height: 4, borderRadius: 4, bgcolor: "rgba(255,255,255,0.07)",
          "& .MuiLinearProgress-bar": { bgcolor: barColor, borderRadius: 4 }
        }}
      />
    </Box>
  );
}
